import { EncryptionMode, UID } from "agora-rtc-sdk-ng";

export const config: configType = {
  uid: 0,
  // appId: "99ce80a3d250481f8b0abda92fb7e6c9",
  // appId: "16a1b01cecbb4972b6f359953d8a7d4a",
  appId: "f2d7308d067d4e878ce454db5b828762",
  channelName: "test",
  rtcToken: "",
  serverUrl: "",
  proxyUrl: "http://localhost:8080/",
  tokenExpiryTime: 600,
  token: "",
  encryptionMode: "aes-128-gcm2",
  salt: "",
  encryptionKey: "",
  destChannelName: "",
  destChannelToken: "",
  destUID: 2,
  secondChannel: "",
  secondChannelToken: "",
  secondChannelUID: 2,
};

export type configType = {
  uid: UID;
  appId: string;
  channelName: string;
  rtcToken: string | null;
  serverUrl: string;
  proxyUrl: string;
  tokenExpiryTime: number;
  token: string;
  encryptionMode: EncryptionMode;
  salt: "";
  encryptionKey: string;
  destUID: number;
  destChannelName: string;
  destChannelToken: string;
  secondChannel: string;
  secondChannelToken: string;
  secondChannelUID: number;
};

export default config;
